// extracted by mini-css-extract-plugin
module.exports =  {"button":"_93444fe79c--button--oJ7i8","icon":"_93444fe79c--icon--MNShP"};